import { createStripeBillingClient } from './stripeClient'
import { createPaddleBillingClient } from './paddleClient'
import type { BillingClient } from './IBillingClient'
import type {BillingProviderPublicConfig} from '@/lib/api/features/billing/getBillingConfig';
import {
  
  getBillingConfig
} from '@/lib/api/features/billing/getBillingConfig'

interface ResolvedClient {
  client: BillingClient
  config: BillingProviderPublicConfig
}

let cached: Promise<ResolvedClient> | null = null

/**
 * Singleton resolver: fetches /api/v1/billing/config once on first call,
 * dynamic-imports the matching client, and returns both. Subsequent calls
 * reuse the same promise — both providers' modules can coexist in the
 * source tree but only the active one's SDK is loaded.
 */
export function getBillingClient(): Promise<ResolvedClient> {
  if (!cached) {
    cached = (async () => {
      const config = await getBillingConfig()
      const client =
        config.provider === 'paddle'
          ? createPaddleBillingClient(
              config.publicKey,
              (config.environment as 'sandbox' | 'production') ?? 'sandbox',
            )
          : createStripeBillingClient(config.publicKey)
      return { client, config }
    })().catch((error) => {
      // Don't trap a one-time fetch failure in the cache — let the next
      // caller retry.
      cached = null
      throw error
    })
  }
  return cached
}
